import {Injectable} from '@angular/core';
import {Action, State, StateContext, StateToken, Store} from '@ngxs/store';

import {QUERYABLE_STATE_MODEL_DEFAULTS, QueryableState, QueryableStateModel} from '../../../../common/state/queryable.state';
import {QueryBuilder} from "../../../../common/query/query.builder";
import {UpdateInventorySiteActiveSiderSection} from "./inventory-site.actions";

const INVENTORY_SITE_STATE_TOKEN = new StateToken<InventorySiteStateModel>('inventory_site');

export interface InventorySiteStateModel extends QueryableStateModel<any> {

}

@State<InventorySiteStateModel>({
  name: INVENTORY_SITE_STATE_TOKEN,
  defaults: {...QUERYABLE_STATE_MODEL_DEFAULTS},
})
@Injectable()
// @ts-ignore
export class InventorySiteState extends QueryableState {
  constructor(
    public store: Store,
    public queryBuilder: QueryBuilder,
  ) {
    super(store, queryBuilder);
  }

  // @ts-ignore
  @Action(UpdateInventorySiteActiveSiderSection)
  updateInventorySiteActiveSiderSection(ctx: StateContext<any>, action: any): void {
    ctx.patchState({
      activeSiderSection: action.name || null
    })
  }
}
